import { css, keyframes } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import coinImage from 'src/assets/images/fortune/img_nookpoint_many.svg';
import { FadeInImage } from 'src/components/shared/FadeInImage';
import { ThornBalloon } from '../../common/ThornBalloon';
import { CoinFlowBg } from './CoinFlowBg';

const bounce = keyframes`
	0%, 35%, 44%, 52%, 100% { transform: translateY(0); }
	40% { transform: translateY(-4px); }
	50% { transform: translateY(-2px); }
`;
interface PointRateProps {
  pointFactor: number;
}

const Double: React.FC = ({ children }) => (
  <div
    className={css`
      background: #f5a73e;
      padding: 6px 24px;
      border-radius: 16px;
    `}
  >
    {children}
  </div>
);

const YourRate: React.FC<{ pointFactor: 2 | 3 }> = ({ pointFactor }) => {
  const { t } = useTranslation('fortune');
  let Wrapper: React.FC;
  switch (pointFactor) {
    case 3:
      Wrapper = ThornBalloon;
      break;
    case 2:
      Wrapper = Double;
      break;
    default:
      return null;
  }
  return (
    <div
      className={css`
        .desc-todays-your-rate {
          font-size: 12px;
        }
        .desc-point-rate {
          font-size: 16px;
        }
        z-index: 1;
        @media (prefers-reduced-motion: no-preference) {
          animation: ${bounce} 2s linear infinite;
        }
      `}
      role="img"
      aria-labelledby={'point-rate-desc-1 point-rate-desc-2'}
    >
      <Wrapper>
        <p id="point-rate-desc-1" className="desc-todays-your-rate">
          {t('point_rate_preface')}
        </p>
        <p id="point-rate-desc-2" className="desc-point-rate">
          {t('point_rate', { n: pointFactor })}
        </p>
      </Wrapper>
    </div>
  );
};

export const PointRate: React.FC<PointRateProps> = ({ pointFactor }) => {
  return (
    <div
      className={css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 80px;
        width: 100%;
        padding: 0 24px;
        color: ${pointFactor === 2 ? '#ffffff' : '#fcee8e'};
        overflow: hidden;
      `}
    >
      {(() => {
        if (pointFactor === 2 || pointFactor === 3) {
          return (
            <>
              <CoinFlowBg pointFactor={pointFactor} />
              <YourRate pointFactor={pointFactor} />
            </>
          );
        } else {
          return <FadeInImage src={coinImage} width={184} height={80} />;
        }
      })()}
    </div>
  );
};
